function getTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        console.log('Tracking: Retrieve of timezone failed');
    }

    return undefined;
}

function calculateViewPortDimensions() {
    const width = Math.max(document?.documentElement?.clientWidth ?? 0, window?.innerWidth ?? 0);
    const height = Math.max(document?.documentElement?.clientHeight ?? 0, window?.innerHeight ?? 0);
    return { width, height };
}

let cachedViewPortDimensions = null;

function resetViewPortDimensionsCache() {
    cachedViewPortDimensions = null;
}

function getViewPortDimensions() {
    if (!cachedViewPortDimensions) {
        cachedViewPortDimensions = calculateViewPortDimensions();
    }
    return cachedViewPortDimensions;
}

if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('resize', () => {
        resetViewPortDimensionsCache();
    });
}

module.exports = {
    getTimezone: getTimezone,
    getViewPortDimensions: getViewPortDimensions,
    resetViewPortDimensionsCache: resetViewPortDimensionsCache
};
